import { withErrorBoundary } from '@sentry/react'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage.tsx'
import { ChannelPage } from '@/pages/messages/ChannelPage'
import { channelMessagesQuery, parseChannelIdParams } from '@/state/channels/channel'

export const Route = createFileRoute('/dashboard/$regionId/messages/channels/$channelId')({
  params: {
    parse: (params) => {
      const parsed = parseChannelIdParams(params)
      if (!parsed) {
        throw notFound()
      }
      return parsed
    },
  },
  component: withErrorBoundary(ChannelPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  loader: async ({ context, params }) => {
    const eveningId = context.region.currentOperatingDate?.eveningId
    if (eveningId !== undefined) {
      await context.queryClient.prefetchQuery(channelMessagesQuery(params.regionId, params.channelId, eveningId))
    }
  },
  gcTime: 5000,
  wrapInSuspense: true,
})
